/* DetailRow — design `.kv > div` */
.detailRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 14px;
  padding: 11px 0;
  font-size: var(--font-size-m);
}

.detailRow:not(:last-child) {
  border-bottom: 1px solid var(--color-grey-lightest);
}

.detailLabel {
  color: var(--color-grey);
  flex: 0 0 auto;
}

.detailValue {
  color: var(--color-text);
  text-align: right;
  min-width: 0;
  flex: 1;
  overflow-wrap: anywhere;
}

.detailActions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

/* Three fixed columns: label · value · actions. */
.grid {
  display: grid;
  grid-template-columns: var(--detail-label-w, 160px) minmax(0, 1fr) var(--detail-actions-w, 0px);
  align-items: start;
}

.grid .detailActions:empty {
  display: none;
}
